var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortTheParagraphs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 175C58.7776 175 25.2002 141.423 25.2002 100C25.2002 58.5774 58.7776 25 100.2 25C141.623 25 175.2 58.5774 175.2 100C175.2 141.423 141.623 175 100.2 175Z",
    fill: "url(#paint0_linear_26801_4513)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7295 36C39.7295 32.6863 42.4158 30 45.7295 30H153.729C157.043 30 159.729 32.6863 159.729 36V164C159.729 167.314 157.043 170 153.729 170H45.7295C42.4158 170 39.7295 167.314 39.7295 164V36Z",
    fill: "url(#paint1_linear_26801_4513)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2002 77C49.0956 77 48.2002 77.8954 48.2002 79V83.5C48.2002 84.0523 47.7525 84.5 47.2002 84.5C46.6479 84.5 46.2002 84.0523 46.2002 83.5V79C46.2002 76.7909 47.9911 75 50.2002 75H54.3669C54.9191 75 55.3669 75.4477 55.3669 76C55.3669 76.5523 54.9191 77 54.3669 77H50.2002ZM61.7002 76C61.7002 75.4477 62.1479 75 62.7002 75H71.0335C71.5858 75 72.0335 75.4477 72.0335 76C72.0335 76.5523 71.5858 77 71.0335 77H62.7002C62.1479 77 61.7002 76.5523 61.7002 76ZM78.3669 76C78.3669 75.4477 78.8146 75 79.3669 75H87.7002C88.2525 75 88.7002 75.4477 88.7002 76C88.7002 76.5523 88.2525 77 87.7002 77H79.3669C78.8146 77 78.3669 76.5523 78.3669 76ZM95.0335 76C95.0335 75.4477 95.4812 75 96.0335 75H104.367C104.919 75 105.367 75.4477 105.367 76C105.367 76.5523 104.919 77 104.367 77H96.0335C95.4812 77 95.0335 76.5523 95.0335 76ZM111.7 76C111.7 75.4477 112.148 75 112.7 75H121.034C121.586 75 122.034 75.4477 122.034 76C122.034 76.5523 121.586 77 121.034 77H112.7C112.148 77 111.7 76.5523 111.7 76ZM128.367 76C128.367 75.4477 128.815 75 129.367 75H137.7C138.252 75 138.7 75.4477 138.7 76C138.7 76.5523 138.252 77 137.7 77H129.367C128.815 77 128.367 76.5523 128.367 76ZM145.034 76C145.034 75.4477 145.481 75 146.034 75H150.2C152.409 75 154.2 76.7909 154.2 79V83.5C154.2 84.0523 153.752 84.5 153.2 84.5C152.648 84.5 152.2 84.0523 152.2 83.5V79C152.2 77.8954 151.305 77 150.2 77H146.034C145.481 77 145.034 76.5523 145.034 76ZM47.2002 91.5C47.7525 91.5 48.2002 91.9477 48.2002 92.5V97C48.2002 98.1046 49.0956 99 50.2002 99H54.3669C54.9191 99 55.3669 99.4477 55.3669 100C55.3669 100.552 54.9191 101 54.3669 101H50.2002C47.9911 101 46.2002 99.2091 46.2002 97V92.5C46.2002 91.9477 46.6479 91.5 47.2002 91.5ZM153.2 91.5C153.752 91.5 154.2 91.9477 154.2 92.5V97C154.2 99.2091 152.409 101 150.2 101H146.034C145.481 101 145.034 100.552 145.034 100C145.034 99.4477 145.481 99 146.034 99H150.2C151.305 99 152.2 98.1046 152.2 97V92.5C152.2 91.9477 152.648 91.5 153.2 91.5ZM61.7002 100C61.7002 99.4477 62.1479 99 62.7002 99H71.0335C71.5858 99 72.0335 99.4477 72.0335 100C72.0335 100.552 71.5858 101 71.0335 101H62.7002C62.1479 101 61.7002 100.552 61.7002 100ZM78.3669 100C78.3669 99.4477 78.8146 99 79.3669 99H87.7002C88.2525 99 88.7002 99.4477 88.7002 100C88.7002 100.552 88.2525 101 87.7002 101H79.3669C78.8146 101 78.3669 100.552 78.3669 100ZM95.0335 100C95.0335 99.4477 95.4812 99 96.0335 99H104.367C104.919 99 105.367 99.4477 105.367 100C105.367 100.552 104.919 101 104.367 101H96.0335C95.4812 101 95.0335 100.552 95.0335 100ZM111.7 100C111.7 99.4477 112.148 99 112.7 99H121.034C121.586 99 122.034 99.4477 122.034 100C122.034 100.552 121.586 101 121.034 101H112.7C112.148 101 111.7 100.552 111.7 100ZM128.367 100C128.367 99.4477 128.815 99 129.367 99H137.7C138.252 99 138.7 99.4477 138.7 100C138.7 100.552 138.252 101 137.7 101H129.367C128.815 101 128.367 100.552 128.367 100Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2002 82C50.2002 80.3431 51.5433 79 53.2002 79H104.2C105.857 79 107.2 80.3431 107.2 82V94C107.2 95.6569 105.857 97 104.2 97H53.2002C51.5433 97 50.2002 95.6569 50.2002 94V82Z",
    fill: "url(#paint2_linear_26801_4513)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 82C111.2 80.3431 112.543 79 114.2 79H147.2C148.857 79 150.2 80.3431 150.2 82V94C150.2 95.6569 148.857 97 147.2 97H114.2C112.543 97 111.2 95.6569 111.2 94V82Z",
    fill: "url(#paint3_linear_26801_4513)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_4513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7295 112C81.7295 110.343 83.0726 109 84.7295 109H115.929C117.586 109 118.929 110.343 118.929 112V124.2C118.929 125.857 117.586 127.2 115.929 127.2H84.7295C83.0726 127.2 81.7295 125.857 81.7295 124.2V112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.729 112C122.729 110.343 124.073 109 125.729 109H146.729C148.386 109 149.729 110.343 149.729 112V124C149.729 125.657 148.386 127 146.729 127H125.729C124.073 127 122.729 125.657 122.729 124V112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7295 112C49.7295 110.343 51.0726 109 52.7295 109H74.7295C76.3863 109 77.7295 110.343 77.7295 112V124C77.7295 125.657 76.3863 127 74.7295 127H52.7295C51.0726 127 49.7295 125.657 49.7295 124V112Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_4513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7295 51.8765C49.7295 50.2196 51.0726 48.8765 52.7295 48.8765H74.7295C76.3863 48.8765 77.7295 50.2196 77.7295 51.8765V63.1798C77.7295 64.8367 76.3863 66.1798 74.7295 66.1798H52.7295C51.0726 66.1798 49.7295 64.8367 49.7295 63.1798V51.8765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7295 52C81.7295 50.3432 83.0726 49 84.7295 49H125.729C127.386 49 128.729 50.3432 128.729 52V63C128.729 64.6569 127.386 66 125.729 66H84.7295C83.0726 66 81.7295 64.6569 81.7295 63V52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.729 51.8765C132.729 50.2196 134.073 48.8765 135.729 48.8765H146.729C148.386 48.8765 149.729 50.2196 149.729 51.8765V63.1798C149.729 64.8367 148.386 66.1798 146.729 66.1798H135.729C134.073 66.1798 132.729 64.8367 132.729 63.1798V51.8765Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_4513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3296 142.2C49.3296 140.543 50.6727 139.2 52.3296 139.2H90.7296C92.3864 139.2 93.7296 140.543 93.7296 142.2V153C93.7296 154.657 92.3864 156 90.7296 156H52.3296C50.6727 156 49.3296 154.657 49.3296 153V142.2Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_26801_4513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7295 142C97.7295 140.343 99.0726 139 100.729 139H146.729C148.386 139 149.729 140.343 149.729 142V153C149.729 154.657 148.386 156 146.729 156H100.729C99.0726 156 97.7295 154.657 97.7295 153V142Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_4513",
    x: 49.7295,
    y: 108,
    width: 100,
    height: 19.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_4513",
    result: "effect2_innerShadow_26801_4513"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_4513",
    x: 49.7295,
    y: 47.8765,
    width: 100,
    height: 18.3034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_4513",
    result: "effect2_innerShadow_26801_4513"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_4513",
    x: 49.3296,
    y: 138.2,
    width: 44.3999,
    height: 17.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_4513",
    result: "effect2_innerShadow_26801_4513"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_26801_4513",
    x: 97.7295,
    y: 138,
    width: 52,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_4513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_4513",
    result: "effect2_innerShadow_26801_4513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_4513",
    x1: 25.2002,
    y1: 36.7188,
    x2: 168.169,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_4513",
    x1: 99.7295,
    y1: 30,
    x2: 99.7295,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_4513",
    x1: 61.1377,
    y1: 79,
    x2: 73.4962,
    y2: 121.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_4513",
    x1: 61.1377,
    y1: 79,
    x2: 73.4962,
    y2: 121.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTheParagraphs);
export default __webpack_public_path__ + "static/media/Sort-the-Paragraphs.3e13e9ff9ef007697d352e515f45b39e.svg";
export { ForwardRef as ReactComponent };